import React, { createContext, useContext, useMemo } from 'react'
import useFolderListener from '../comps/configs/dyson/useFolderListener';


// ------------  Context --------------------//
const FolderListenerContext = createContext();


// ------------  STATIC  ----------------------------------------------------------------------------- //



// ------------  Provider ---------------------------------------------------------------------------- //
export const FolderListenerContextProvider = ({children}) => {

  // Folder Created, Renamed, Deleted
  const { folderChanged, 
          tagFolderCreatedError, 
          clearErrorFolderCreated,
          clearErrorFolderRenamed,
          tagCreateFolderInProgress,
          clearFolderKInfo,
          tagFolderEdit
        }                                = useFolderListener();

  const memoizedValue = useMemo(()=>({
          folderChanged,
          tagFolderCreatedError, 
          clearErrorFolderCreated,
          clearErrorFolderRenamed, 
          tagCreateFolderInProgress, 
          clearFolderKInfo,
          tagFolderEdit
  }),   [ folderChanged, tagFolderCreatedError, clearErrorFolderRenamed, tagCreateFolderInProgress, clearErrorFolderCreated,
          clearFolderKInfo, tagFolderEdit
        ]);

  return (
    <FolderListenerContext.Provider value={memoizedValue}>{children}</FolderListenerContext.Provider>
  )
}

export function useFolderListenerContext() {
  return useContext(FolderListenerContext);
}